// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LOX0a0O7 {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 2rem 1rem;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
}
.LOX0a0O7::before {
  content: '';
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: -1;
  pointer-events: none;
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .LOX0a0O7 {
    display: block;
    -webkit-box-align: initial;
    -webkit-align-items: initial;
            align-items: initial;
    -webkit-box-pack: initial;
    -webkit-justify-content: initial;
            justify-content: initial;
    padding: 0.75rem 1rem;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-y;
  }
  .LOX0a0O7::after {
    content: '';
    display: block;
    height: 0.75rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .LOX0a0O7 {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
            justify-content: center;
    padding: 0.5rem 1rem;
  }
  .LOX0a0O7::after {
    display: none;
  }
}
.gQJkD7ql {
  position: relative;
  width: 100%;
  max-width: 22.5rem;
  box-sizing: border-box;
  padding: 2.25rem 2rem 2rem;
  background: #fffdf4;
  border-radius: 2rem;
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.18);
  -webkit-animation: mcKbNPz4 0.3s ease;
          animation: mcKbNPz4 0.3s ease;
  overflow: visible;
  text-align: center;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}
@media (max-width: 767px) {
  .gQJkD7ql {
    max-width: 90%;
    padding: 2rem 1.5rem 1.75rem;
    border-radius: 1.75rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .gQJkD7ql {
    width: min(22.5rem, 82vw);
    max-width: min(22.5rem, 82vw);
    padding: 2rem 1.5rem 1.75rem;
    border-radius: 1.75rem;
    margin: auto;
  }
}
@-webkit-keyframes mcKbNPz4 {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes mcKbNPz4 {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
.xVEUJ23S {
  background: none;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: absolute;
  top: -0.75rem;
  right: -1.25rem;
  width: 3.5rem;
  height: 3.5rem;
  padding: 0;
  border: none;
  background: transparent;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  cursor: pointer;
  z-index: 2;
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
.xVEUJ23S:hover {
  -webkit-transform: scale(1.05);
          transform: scale(1.05);
}
.xVEUJ23S:active {
  -webkit-transform: scale(0.95);
          transform: scale(0.95);
}
@media (max-width: 767px) {
  .xVEUJ23S {
    top: -0.625rem;
    right: -0.875rem;
    width: 3rem;
    height: 3rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .xVEUJ23S {
    top: -0.625rem;
    right: -0.875rem;
    width: 3rem;
    height: 3rem;
  }
}
.kY74CBWv {
  width: 100%;
  height: 100%;
  display: block;
  -o-object-fit: contain;
     object-fit: contain;
}
.WApmN42S {
  margin: 0 0 1rem;
  font-size: 1.5rem;
  font-weight: bold;
  color: #5e5447;
  line-height: 1.3;
}
@media (max-width: 767px) {
  .WApmN42S {
    font-size: 1.25rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .WApmN42S {
    font-size: 1.25rem;
    line-height: 1.3;
  }
}
.y88kHktK {
  margin: 0 0 1.5rem;
  font-size: 1rem;
  font-weight: bold;
  color: #5e5447;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .y88kHktK {
    font-size: 0.875rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .y88kHktK {
    font-size: 0.875rem;
    line-height: 1.5;
  }
}
.T12XyjTO {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .T12XyjTO {
    margin-bottom: 1rem;
  }
}
.nyWdBqGD {
  width: 1.125rem;
  height: 1.125rem;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 1px solid #d8c4a0;
  border-radius: 0.25rem;
  background: #ffffff;
  position: relative;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  cursor: pointer;
}
.nyWdBqGD:checked {
  border-color: #ff8100;
  background: #ff8100;
}
.nyWdBqGD:checked::after {
  content: '';
  position: absolute;
  top: 0.125rem;
  left: 0.3125rem;
  width: 0.25rem;
  height: 0.5rem;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
          transform: rotate(45deg);
}
.yqATvQDr {
  font-size: 0.875rem;
  color: #c3a07a;
  font-weight: bold;
  line-height: 1.4;
}
.RWMceyS6 {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  gap: 1rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
          justify-content: space-between;
  min-width: 0;
}
@media (max-width: 767px) {
  .RWMceyS6 {
    gap: 0.5rem;
    width: 100%;
    margin: 0 auto;
  }
}
.GdIqccVx,
.JeyKI33F {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  min-width: 0;
  aspect-ratio: 72 / 25;
  min-height: 1.5625rem;
  border-radius: 999px;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1rem;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease, border-color 0.2s ease, -webkit-transform 0.2s ease;
  transition: background-color 0.2s ease, border-color 0.2s ease, -webkit-transform 0.2s ease;
  transition: background-color 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
  transition: background-color 0.2s ease, transform 0.2s ease, border-color 0.2s ease, -webkit-transform 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
}
.GdIqccVx:active,
.JeyKI33F:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .GdIqccVx,
  .JeyKI33F {
    font-size: 0.875rem;
    min-width: 0;
    min-height: 2.75rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .GdIqccVx,
  .JeyKI33F {
    min-height: 2.75rem;
    font-size: 0.875rem;
  }
}
.GdIqccVx {
  background: #ff8100;
  color: #ffffff;
  border: none;
  font-weight: 500;
}
.GdIqccVx:hover {
  background: #e67400;
}
.JeyKI33F {
  background: #ffffff;
  color: #5e5447;
  border: 1px solid #fbd9b9;
  font-weight: normal;
}
.JeyKI33F:hover {
  background: rgba(255, 255, 255, 0.85);
}
`, "",{"version":3,"sources":["webpack://./src/components/LogoutModal/LogoutModal.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAQA;EACE,eAAA;EACA,QAAA;EACA,aAAA;ECkDA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDlDA,kBAAA;EC4GA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,iCAAA;EACA,mBAAA;ADhHF;ACkHE;EACE,WAAA;EACA,eAAA;EACA,QAAA;EACA,+BAAA;EACA,0BAAA;EACA,kCAAA;EACA,WAAA;EACA,oBAAA;ADhHJ;ACsHE;EAAA;IACE,cAAA;IACA,0BAAA;IAAA,4BAAA;YAAA,oBAAA;IACA,yBAAA;IAAA,gCAAA;YAAA,wBAAA;IACA,qBAAA;IACA,kBAAA;IACA,gBAAA;IACA,4BAAA;IACA,iCAAA;IACA,mBAAA;EDnHF;ECqHE;IACE,WAAA;IACA,cAAA;IACA,eAAA;EDnHJ;AACF;AAxBE;EAAA;IACE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,wBAAA;IAAA,+BAAA;YAAA,uBAAA;IACA,oBAAA;EA2BF;EAzBE;IACE,aAAA;EA2BJ;AACF;AAvBA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;EACA,+CAAA;EACA,qCAAA;UAAA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,+EAAA;AAyBF;AC/DE;EAAA;IDyCE,cAAA;IACA,4BAAA;IACA,sBAAA;EA0BF;AACF;AAxBE;EAAA;IACE,yBAAA;IACA,6BAAA;IACA,4BAAA;IACA,sBAAA;IACA,YAAA;EA2BF;AACF;AAxBA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EA0BF;EAxBA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EA0BF;AACF;AAlCA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EA0BF;EAxBA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EA0BF;AACF;AAvBA;ECmCE,gBAAA;EAEA,SAAA;EAEA,aAAA;EACA,oBAAA;EDtCA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,+CAAA;EAAA,uCAAA;EAAA,+BAAA;EAAA,4DAAA;AA4BF;AA1BE;EACE,8BAAA;UAAA,sBAAA;AA4BJ;AAzBE;EACE,8BAAA;UAAA,sBAAA;AA2BJ;ACnHE;EAAA;ID4FE,cAAA;IACA,gBAAA;IACA,WAAA;IACA,YAAA;EA2BF;AACF;AAzBE;EAAA;IACE,cAAA;IACA,gBAAA;IACA,WAAA;IACA,YAAA;EA4BF;AACF;AAzBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;KAAA,mBAAA;AA2BF;AAxBA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AA0BF;AChJE;EAAA;IDyHE,kBAAA;EA2BF;AACF;AAzBE;EAAA;IACE,kBAAA;IACA,gBAAA;EA4BF;AACF;AAzBA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AA2BF;AClKE;EAAA;ID0IE,mBAAA;EA4BF;AACF;AA1BE;EAAA;IACE,mBAAA;IACA,gBAAA;EA6BF;AACF;AA1BA;EACE,2BAAA;EAAA,4BAAA;EAAA,oBAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AA4BF;AA1BE;EAAA;IACE,mBAAA;EA6BF;AACF;AA1BA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;UAAA,cAAA;EACA,qBAAA;OAAA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EAAA,yBAAA;EACA,eAAA;AA4BF;AA1BE;EACE,qBAAA;EACA,mBAAA;AA4BJ;AA1BI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,gCAAA;UAAA,wBAAA;AA4BN;AAvBA;EACE,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAyBF;AAtBA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,SAAA;EACA,yBAAA;EAAA,sCAAA;UAAA,8BAAA;EACA,YAAA;AAwBF;ACnOE;EAAA;ID8ME,WAAA;IACA,WAAA;IACA,cAAA;EAyBF;AACF;AAtBA;;EChHE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;ED6GA,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,+EAAA;EACA,eAAA;EACA,eAAA;EACA,mGAAA;EAAA,2FAAA;EAAA,mFAAA;EAAA,gHAAA;EChHA,mBAAA;EACA,kBAAA;EDiHA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;AA8BF;AA5BE;;EACE,8BAAA;UAAA,sBAAA;AA+BJ;ACrQE;EAAA;;ID0OE,mBAAA;IACA,YAAA;IACA,mBAAA;EAgCF;AACF;AA9BE;EAAA;;IACE,mBAAA;IACA,mBAAA;EAkCF;AACF;AA/BA;EACE,mBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAiCF;AA/BE;EACE,mBAAA;AAiCJ;AA7BA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;AA+BF;AA7BE;EACE,qCAAA;AA+BJ","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n@logout-modal-bg: #fffdf4;\n@logout-modal-text: #5e5447;\n@logout-modal-orange: #ff8100;\n@logout-modal-orange-dark: #e67400;\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  z-index: @z-index-modal;\n  .flex-center();\n  padding: @spacing-xl @spacing-md;\n  .modalOverlayBackdrop();\n\n  .touchLandscapeModalOverlay(0.75rem, 1rem);\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: @spacing-sm @spacing-md;\n\n    &::after {\n      display: none;\n    }\n  }\n}\n\n.modal {\n  position: relative;\n  width: 100%;\n  max-width: 22.5rem;\n  box-sizing: border-box;\n  padding: 2.25rem 2rem 2rem;\n  background: @logout-modal-bg;\n  border-radius: 2rem;\n  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.18);\n  animation: slideUp 0.3s ease;\n  overflow: visible;\n  text-align: center;\n  font-family: @font-family-sans;\n\n  .mobile({\n    max-width: 90%;\n    padding: 2rem 1.5rem 1.75rem;\n    border-radius: 1.75rem;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    width: min(22.5rem, 82vw);\n    max-width: min(22.5rem, 82vw);\n    padding: 2rem 1.5rem 1.75rem;\n    border-radius: 1.75rem;\n    margin: auto;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(1.25rem);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.closeButton {\n  .button-reset();\n  position: absolute;\n  top: -0.75rem;\n  right: -1.25rem;\n  width: 3.5rem;\n  height: 3.5rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2;\n  transition: transform 0.2s ease;\n\n  &:hover {\n    transform: scale(1.05);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  .mobile({\n    top: -0.625rem;\n    right: -0.875rem;\n    width: 3rem;\n    height: 3rem;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    top: -0.625rem;\n    right: -0.875rem;\n    width: 3rem;\n    height: 3rem;\n  }\n}\n\n.closeButtonImg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n}\n\n.title {\n  margin: 0 0 @spacing-md;\n  font-size: @font-size-xxl;\n  font-weight: bold;\n  color: @logout-modal-text;\n  line-height: 1.3;\n\n  .mobile({\n    font-size: @font-size-xl;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    font-size: @font-size-xl;\n    line-height: 1.3;\n  }\n}\n\n.description {\n  margin: 0 0 @spacing-lg;\n  font-size: @font-size-md;\n  font-weight: bold;\n  color: @logout-modal-text;\n  line-height: 1.5;\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    font-size: @font-size-sm;\n    line-height: 1.5;\n  }\n}\n\n.checkboxLabel {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: @spacing-sm;\n  margin-bottom: @spacing-xl;\n  cursor: pointer;\n  user-select: none;\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    margin-bottom: @spacing-md;\n  }\n}\n\n.checkbox {\n  width: 1.125rem;\n  height: 1.125rem;\n  flex-shrink: 0;\n  appearance: none;\n  -webkit-appearance: none;\n  border: 1px solid #d8c4a0;\n  border-radius: 0.25rem;\n  background: @white;\n  position: relative;\n  transition: all 0.2s ease;\n  cursor: pointer;\n\n  &:checked {\n    border-color: @logout-modal-orange;\n    background: @logout-modal-orange;\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0.125rem;\n      left: 0.3125rem;\n      width: 0.25rem;\n      height: 0.5rem;\n      border: solid @white;\n      border-width: 0 2px 2px 0;\n      transform: rotate(45deg);\n    }\n  }\n}\n\n.checkboxText {\n  font-size: @font-size-sm;\n  color: #c3a07a;\n  font-weight: bold;\n  line-height: 1.4;\n}\n\n.actions {\n  display: flex;\n  gap: @spacing-md;\n  justify-content: space-between;\n  min-width: 0;\n\n  .mobile({\n    gap: @spacing-sm;\n    width: 100%;\n    margin: 0 auto;\n  });\n}\n\n.confirmButton,\n.cancelButton {\n  .button-reset();\n  flex: 1;\n  min-width: 0;\n  aspect-ratio: 72 / 25;\n  min-height: 1.5625rem;\n  border-radius: 999px;\n  font-family: @font-family-sans;\n  font-size: @font-size-md;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease, border-color 0.2s ease;\n  .touch-friendly();\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .mobile({\n    font-size: @font-size-sm;\n    min-width: 0;\n    min-height: 2.75rem;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    min-height: 2.75rem;\n    font-size: @font-size-sm;\n  }\n}\n\n.confirmButton {\n  background: @logout-modal-orange;\n  color: @white;\n  border: none;\n  font-weight: 500;\n\n  &:hover {\n    background: @logout-modal-orange-dark;\n  }\n}\n\n.cancelButton {\n  background: @white;\n  color: @logout-modal-text;\n  border: 1px solid #fbd9b9;\n  font-weight: normal;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.85);\n  }\n}\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n// 可滚动弹窗蒙版：背景 fixed 铺满视口，内容区单独滚动，避免移动端滑出未覆盖区域\n.modalOverlayBackdrop(@bg: rgba(0, 0, 0, 0.55)) {\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  touch-action: pan-y;\n\n  &::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: @bg;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    z-index: -1;\n    pointer-events: none;\n  }\n}\n\n// 触屏设备横屏时高度很矮，弹窗蒙版必须允许自身滚动，并从顶部开始排布。\n.touchLandscapeModalOverlay(@padding-y: @spacing-sm, @padding-x: @spacing-md) {\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    display: block;\n    align-items: initial;\n    justify-content: initial;\n    padding: @padding-y @padding-x;\n    overflow-x: hidden;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n    touch-action: pan-y;\n\n    &::after {\n      content: '';\n      display: block;\n      height: @padding-y;\n    }\n  }\n}\n\n.touchLandscapeModalBox(@max-height-gap: (@spacing-sm * 2)) {\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    max-height: calc(var(--app-viewport-height, 100dvh) - @max-height-gap);\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `LOX0a0O7`,
	"modal": `gQJkD7ql`,
	"slideUp": `mcKbNPz4`,
	"closeButton": `xVEUJ23S`,
	"closeButtonImg": `kY74CBWv`,
	"title": `WApmN42S`,
	"description": `y88kHktK`,
	"checkboxLabel": `T12XyjTO`,
	"checkbox": `nyWdBqGD`,
	"checkboxText": `yqATvQDr`,
	"actions": `RWMceyS6`,
	"confirmButton": `GdIqccVx`,
	"cancelButton": `JeyKI33F`
};
export default ___CSS_LOADER_EXPORT___;
